import React from "react";
import Modal from "react-modal";
import IActiveLoginMessage from "../../../models/IActiveLoginMessage";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import "./LoginMessageAcknowledgeModal.scss";

type Props = {
    message: IActiveLoginMessage;
    onAcknowledge: () => void | Promise<void>;
    acknowledging?: boolean;
    error?: string | null;
    /** Tests pass false; production leaves the default so react-modal hides the app for screen readers. */
    ariaHideApp?: boolean;
};

const noop = () => {};

/**
 * Blocking "I understand" dialog for a login message that requires acknowledgment. Deliberately has
 * no close affordance: no X, no Escape, no overlay click. It is its own react-modal instance (not the
 * shared UiContext modal) so nothing else in the app can dismiss or replace it.
 */
export const LoginMessageAcknowledgeModal = (props: Props) => {
    const { message } = props;
    const accentColor = message.color || "#FFFFFF";
    const appElement = typeof document !== "undefined" ? document.getElementById("root") || undefined : undefined;

    return (
        <Modal
            id={"loginMessageAcknowledgeModal"}
            isOpen={true}
            ariaHideApp={props.ariaHideApp}
            appElement={props.ariaHideApp === false ? undefined : appElement}
            contentLabel={message.title || "Login message"}
            shouldCloseOnEsc={false}
            shouldCloseOnOverlayClick={false}
            onRequestClose={noop}
            className={"LoginMessageAcknowledgeModal"}
            overlayClassName={"LoginMessageAcknowledgeModal__overlay"}
            style={{}}>
            <div className={"LoginMessageAcknowledgeModal__body"} style={{ "--login-message-accent": accentColor } as React.CSSProperties}>
                <div className={"LoginMessageAcknowledgeModal__header"}>
                    {message.icon ? <i className={message.icon + " LoginMessageAcknowledgeModal__icon"} aria-hidden={true}></i> : null}
                    {message.title ? <h2 className={"LoginMessageAcknowledgeModal__title"}>{message.title}</h2> : null}
                </div>

                <div className={"LoginMessageAcknowledgeModal__detail"} dangerouslySetInnerHTML={{ __html: message.detail || "" }}></div>

                <p className={"LoginMessageAcknowledgeModal__help"}>
                    <OwLabel title={"login_message_acknowledge_help"} />
                </p>

                {props.error ? (
                    <div className={"alert alert-danger LoginMessageAcknowledgeModal__error"} role={"alert"}>
                        <OwLabel title={"login_message_acknowledge_error"} />
                    </div>
                ) : null}

                <div className={"LoginMessageAcknowledgeModal__actions"}>
                    <OwButton
                        title={"i_understand"}
                        className={"btn-primary"}
                        leftIconClass={"fa fa-check"}
                        disabled={!!props.acknowledging}
                        fn={() => {
                            props.onAcknowledge();
                        }}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default LoginMessageAcknowledgeModal;
